import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=c5400fc6&scoped=true&"
import script from "./BankTransfer.vue?vue&type=script&lang=js&"
export * from "./BankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=c5400fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5400fc6",
  null
  
)

export default component.exports